import { useQuery } from '@tanstack/react-query'
import { api } from '@/api/client'
import type { JobRun, JobRunsFilter, JobStats } from '@/api/types'

export function useJobRuns(filter: JobRunsFilter = {}) {
  return useQuery({
    queryKey: ['job-runs', filter],
    queryFn: () => api.listJobRuns(filter),
    refetchInterval: 10_000,
  })
}

export function useJobStats() {
  return useQuery({
    queryKey: ['job-stats'],
    queryFn: () => api.jobStats(),
    refetchInterval: 10_000,
  })
}

export type { JobRun, JobStats }
